var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2734_18313)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF2124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9011 17.1732L12.6663 15.9217L14.8706 13.7079H8.83511C7.93278 13.7079 7.16794 13.3911 6.54061 12.7576C5.91328 12.124 5.59961 11.356 5.59961 10.4536C5.59961 9.55122 5.91328 8.78322 6.54061 8.14955C7.16794 7.516 7.93278 7.19922 8.83511 7.19922H9.37578V8.96589H8.83511C8.425 8.96589 8.07767 9.11133 7.79311 9.40222C7.50855 9.693 7.36628 10.0434 7.36628 10.4536C7.36628 10.8638 7.50855 11.2143 7.79311 11.5051C8.07767 11.7958 8.425 11.9412 8.83511 11.9412H14.8706L12.6569 9.72022L13.9011 8.47605L18.2403 12.8246L13.9011 17.1732Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2734_18313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.204b4e921341ca0e6c5e231007703163.svg";
export { ForwardRef as ReactComponent };